<template>
    <div class="container-fluid">
        <Breadcrumb title="Message Report" v-bind:button-show="false"></Breadcrumb>
        <div class="row" style="position: relative">
            <div class="col-12">
                <div class="card">
                    <div class="card-header">
                        <button type="button" class="close" v-tooltip.top="'Download xlsx'">
                            <i class="fas fa-file-excel mr-1" aria-hidden="true"
                               @click="getXlsx()" style="font-size: 20px;"></i>
                        </button>
                    </div>
                    <div class="card-body"  v-if="isAdmin">
                        <div class="form-group">
                            <treeselect placeholder="Search by Archive Status"
                                        :clearable=false
                                        v-model="filter.archiveStatus"
                                        :options="archiveStatusSelect"/>
                        </div>
                        <div class="input-group form-group" v-if="isAdmin">
                            <label>User</label>
                            <treeselect placeholder="All"
                                        v-model="filter.userId"
                                        :multiple="false"
                                        :options="userList"
                                        :load-options="loadUserList"
                                        :auto-load-root-options="true"
                            />
                        </div>
                        <div class="form-row">
                            <div class="col-2">
                                <button class="btn btn-info btn-rounded text-uppercase waves-effect waves-light w-100"
                                        @click="getItems(page=1)">
                                    Get
                                </button>
                            </div>
                        </div>
                    </div>
                    <div class="card-body">
                        <div class="col-12" v-if="loading" style="min-height:100px;">
                            <Preloader v-bind:class="{preloader: loading}"></Preloader>
                        </div>
                        <div v-else>
                            <div v-if="report.length === 0">{{emptyMessage}}</div>
                            <div v-else>
                                <div>
                                    <div class="table-responsive">
                                        <table class="table">
                                            <thead>
                                            <tr>
                                                <th @click="tableOrdering('id')">
                                                    <span role='button'>Msg ID</span>
                                                </th>
                                                <th @click="tableOrdering('name')">
                                                    <span role='button'>Msg Name</span>
                                                </th>
                                                <th @click="tableOrdering('report.delivered')">
                                                    <span role='button'>Delivery Count</span>
                                                </th>
                                                <th @click="tableOrdering('report.clicked')">
                                                    <span role='button'>Click Count</span>
                                                </th>
                                                <th @click="tableOrdering('report.deliveredToOneClick')">
                                                    <span role='button'>Click:Delivery</span>
                                                </th>
                                                <th @click="tableOrdering('report.conversions')">
                                                    <span role='button'>Conversion Count</span>
                                                </th>
                                                <th @click="tableOrdering('report.clickedToOneConversion')">
                                                    <span role='button'>Conversion:Click</span>
                                                </th>
                                                <th @click="tableOrdering('report.profit')">
                                                    <span role='button'>Profit</span>
                                                </th>
                                                <th @click="tableOrdering('report.profitToOneConversion')">
                                                    <span role='button'>Conversion:Profit</span>
                                                </th>
                                            </tr>
                                            </thead>
                                            <tbody>
                                            <tr v-for="(message, index) in report" :key="index">
                                                <td class="align-middle">{{message.id}}</td>
                                                <td class="align-middle">{{message.name}}</td>
                                                <td class="align-middle">
                                                    <span v-tooltip.top="'Delivery'">{{message.report.delivered}}</span>
                                                </td>
                                                <td class="align-middle" >
                                                    <span v-tooltip.top="'Click'">{{message.report.clicked}}</span>
                                                </td>
                                                <td class="align-middle">
                                                    <span v-tooltip.top="'Click:Delivery'">{{message.report.deliveredToOneClick !== null ? ('1:' + message.report.deliveredToOneClick) : '∞'}}</span>
                                                </td>
                                                <td class="align-middle">
                                                    <span v-tooltip.top="'Conversion'">{{message.report.conversions}}</span>
                                                </td>
                                                <td class="align-middle">
                                                    <span v-tooltip.top="'Conversion:Click'">{{message.report.clickedToOneConversion !== null ? ('1:' + message.report.clickedToOneConversion) : '∞'}}</span>
                                                </td>
                                                <td class="align-middle">
                                                    <span v-tooltip.top="'Profit'">{{message.report.profit / 100}}</span>
                                                </td>
                                                <td class="align-middle">
                                                    <span v-tooltip.top="'Conversion:Profit'">{{message.report.profitToOneConversion !== null ? ('1:' + message.report.profitToOneConversion) : '∞'}}</span>
                                                </td>
                                            </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                    <paginate :click-handler="getItems"
                                              :container-class="'pagination justify-content-center'"
                                              :margin-pages="2"
                                              :next-class="'page-item'"
                                              :next-link-class="'page-link'"
                                              :next-text="'Next'"
                                              :page-class="'page-item'"
                                              :page-count="pageCount"
                                              :page-link-class="'page-link'"
                                              :page-range="3"
                                              :prev-class="'page-item'"
                                              :prev-link-class="'page-link'"
                                              :prev-text="'Prev'"
                                              v-if="pageCount > 1"
                                              v-model="page">
                                    </paginate>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import Treeselect from '@riophae/vue-treeselect';
    import Swal from 'sweetalert2'
    import Preloader from '../components/Preloader';
    import Breadcrumb from '../components/Breadcrumb';
    import ReportService from '../services/ReportService';
    import UserService from '../services/UserService';
    import paginateMixin from '../mixins/paginate-mixin';

    export default {
        name: 'MessageReport',
        components: {
            Treeselect,
            Breadcrumb,
            Preloader,
        },
        mixins: [paginateMixin],
        data() {
            return {
                emptyMessage: '',
                totalItems: 0,
                page: 1,
                perPage: paginateMixin.defaultPerPage,
                report: [],
                userList: null,
                filter: {
                    userId: null,
                    archiveStatus: false,
                },
                order: {
                    field: 'id',
                    direction: 'asc'
                },
                loading: false,
                isAdmin: false,
                archiveStatusSelect: [
                    {id: 'all', label: 'All'},
                    {id: true, label: 'Archive'},
                    {id: false, label: 'Current'}
                ],
                showArchive: false
            }
        },
        mounted() {
            this.isAdmin = this.$store.getters.isAdmin;
            if (!this.isAdmin) {
                this.getItems(this.page);
            }
        },
        methods: {
            loadUserList({callback}) {
                UserService.getUserSelect().then(response => {
                    this.userList = response.data['hydra:member'].map(user => {
                        return {id: user.id, label: user.username}
                    });
                    callback();
                });
            },
            getItems: function (pageNum) {
                this.loading = true;
                this.showArchive = this.archiveStatus !== false;
                ReportService.getMessageReport(
                    pageNum,
                    this.perPage,
                    this.order,
                    this.filter.userId,
                    this.filter.archiveStatus
                ).then(response => {
                    this.report = response.data['hydra:member'];
                    this.totalItems = response.data['hydra:totalItems'];
                    if (this.totalItems === 0) {
                        this.emptyMessage = 'Nothing to show.'
                    } else {
                        this.emptyMessage = ''
                    }
                    this.loading = false;
                }).catch(error => {
                    Swal({
                        type: 'error',
                        title: 'Oops...',
                        text: `${error}`,
                    });
                    this.loading = false;
                });
            },
            tableOrdering(field) {
                if (this.order.field === field) {
                    this.order.direction = (this.order.direction === 'asc') ? 'desc' : 'asc';
                } else {
                    this.order.field = field;
                    this.order.direction = 'asc';
                }
                this.getItems(this.page = 1);
            },
            getXlsx() {
                ReportService.getXlsxMessageReport(JSON.stringify(this.filter)).then(response => {
                    const blob = new Blob([response.data]);
                    const link = document.createElement('a');
                    link.href = URL.createObjectURL(blob);
                    link.download = 'message-report.xlsx';
                    link.click();
                    URL.revokeObjectURL(link.href);
                });
            },
        },
        computed: {
            pageCount: function () {
                return Math.ceil(this.totalItems / this.perPage);
            }
        }
    }
</script>

<style scoped>
    tbody {
        font-size: 14px;
        font-family: Arial, serif;
        margin-left: 20px;
    }
    td {
        padding-left: 20px;
    }
</style>
